import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import { CardTitle } from '../../../components/card/NewCard'
import Input from '../../../components/forms/Input'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import { rpqsShape } from '../../constants/RpqsShapes'

// Champs modifiables d'un RPQS, affichés en mode édition. La clé (année, collectivité) n'est pas modifiable.
const RpqsEditPanel = ({
    rpqs = {},
    onChange = () => {},
}) => (
    <Card>
        <CardTitle title={i18n.updateRpqs} />
        <CardContent>
            <Grid container columnSpacing={1}>
                <Grid size={6}>
                    <Input
                        title={i18n.name}
                        value={rpqs.name}
                        onChange={name => onChange({ name })}
                        obligatory
                    />
                </Grid>
                <Grid size={3}>
                    <SimpleDatePicker
                        label={i18n.startDate}
                        value={rpqs.startDate}
                        onChange={startDate => onChange({ startDate })}
                    />
                </Grid>
                <Grid size={3}>
                    <SimpleDatePicker
                        label={i18n.endDate}
                        value={rpqs.endDate}
                        onChange={endDate => onChange({ endDate })}
                    />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
)

RpqsEditPanel.propTypes = {
    rpqs: rpqsShape,
    onChange: PropTypes.func,
}

export default RpqsEditPanel
